import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";

export default function Header() {
  return (
    <header className="site-header">
      <Navbar expand="md" collapseOnSelect>
        <Container>
          <Navbar.Brand as={Link} to="/" className="site-brand"><span className="brand-mark" aria-hidden="true">lc<span>↗</span></span> LANDER CENTRAL</Navbar.Brand>
          <Navbar.Toggle aria-controls="site-navigation" aria-label="Toggle navigation" />
          <Navbar.Collapse id="site-navigation">
            <Nav className="ms-auto">
              <Nav.Link as={NavLink} to="/projects" eventKey="projects">Our work</Nav.Link>
              <Nav.Link as={NavLink} to="/contact" eventKey="contact">Let’s talk <span aria-hidden="true">↗</span></Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
}
